<template>
      <v-container grid-list-lg class="mt-7 mb-10 pb-16">
        <v-layout row wrap>
          <v-flex xs12 sm6 class="mx-auto">
            <h2>Registrace do Klubu přátel ZOO</h2>
            <v-form v-model="valid" ref="registerForm" lazy-validation @submit.prevent="handleFormSubmit" @keyup.native.enter="register()">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                        label="Jméno"
                        filled
                        v-model="form.firstName"
                        :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                        label="Příjmení"
                        filled
                        v-model="form.lastName"
                        :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                        label="Email"
                        filled
                        v-model="form.email"
                        :rules="[rules.required, rules.email]"
                        :error-messages="errors.email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                        label="Telefon"
                        filled
                        v-model="form.phone"
                        type="number"
                    ></v-text-field>
                  </v-col>
                </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                      label="Město"
                      filled
                      v-model="form.town"
                      :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row align-content="center" justify="center" class="py-5" v-if="loadingInterests">
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
              </v-row>
              <v-row align-content="center" justify="center" class="py-5 v2" v-else>
                <v-list
                    flat
                    subheader
                    three-line
                >
                  <v-subheader class="text-h6">Vyberte si prosím oblasti, o kterých chcete být informováni</v-subheader>

                    <v-list-item v-for="interest in interests" :key="interest.id" @click="changeInterest(interest.id)">
                      <template>
                        <v-list-item-action>
                          <v-checkbox
                            :value="interest.id"
                            v-model="form.interests"
                            @change="changeInterest(interest.id)"
                          ></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ interest.name }}</v-list-item-title>
                          <v-list-item-subtitle>{{  interest.description }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-list-item>

                </v-list>
              </v-row>
              <v-row>
                <v-col cols=12>
                  <v-checkbox
                      v-model="form.marketingAgreement"
                      label="Souhlasím se zasíláním marketingových sdělení"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <vue-recaptcha
                      ref="recaptcha"
                      @verify="onCaptchaVerified"
                      @expired="onCaptchaExpired"
                      size="invisible"
                      :loadRecaptchaScript="true"
                      :sitekey="recaptchaKey">
                  </vue-recaptcha>
                  <v-btn block color="primary" :loading="loading" :disabled="loading" @click="register()">Registrovat</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import {mapActions} from 'vuex'
import ValidationRules from '../utilities/ValidationRules'

    export default {
        name: 'Homepage',
      components: { VueRecaptcha },
      data() {
        return {
          loadingOrderId: false,
          orderItemId: null,
          errors: {},
          form: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            marketingAgreement: false,
            recaptchaToken: '',
            town: '',
            interests: []
          },
          interests: [],
          loadingInterests: false,
          valid: true,
          loading: false,
          rules: ValidationRules.getRules()
        }
      },
      mounted() {
          this.loadInterests();
      },
      computed: {
        recaptchaKey() {
          return process.env.VUE_APP_RECAPTCHA_KEY
        }
      },
      methods: {
          ...mapActions(
              ['showSuccessSnackbar']
          ),
        changeInterest(id) {
          const found = this.form.interests.find(element => element === id);
          if (!found) {
            this.form.interests.push(id);
          } else {
            this.form.interests = this.form.interests.filter(function(e) { return e !== id })
          }
        },
          loadInterests() {
            this.loadingInterests = true;
            window.axios.get(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_API_REGISTER + '/interests').then(response => {
              this.interests = response.data;
              this.loadingInterests = false;
            }).catch(error => {console.log(error)});
          },
        onCaptchaVerified: function (recaptchaToken) {
          const self = this;
          self.$refs.recaptcha.reset();
          self.form.recaptchaToken = recaptchaToken;
          window.axios.put(process.env.VUE_APP_ROOT_API + process.env.VUE_APP_API_REGISTER, self.form).then(response => {
            this.onSuccess(response);
          }).catch(error => {this.onError(error)});

        },
        onCaptchaExpired: function () {
          this.$refs.recaptcha.reset();
        },
        register() {
          if (this.$refs.registerForm.validate()) {
            this.loading = true;
            this.$refs.recaptcha.execute();
          }
        },
        //eslint-disable-next-line
        onSuccess(response) {
          this.loading = false;
          this.$refs.registerForm.reset();
          this.form.interests = [];
          this.showSuccessSnackbar('Registrace do Klubu přátel Zoo proběhla v pořádku!')
        },
        onError(error) {
            this.loading = false;
            const $t = this.$t.bind(this);
          if (error.data.errors) {
           error.data.errors.forEach(element => {
              this.errors[element.field] = $t(element.msg);
            });
          }
        }
      }
    }
</script>

<style>
.v1 .v-chip-group--column .v-slide-group__content {
  display: block
}

.v1 .v-chip-group--column .v-chip {
  float: left;
  clear: both;
}

.v2 .v-chip-group--column .v-slide-group__content {
  flex-direction: column
}
</style>
